import React from 'react';
import { FaPaperclip, FaCloudUploadAlt, FaTimes, FaFilePdf, FaFileExcel } from 'react-icons/fa';

const ReportAttachments = ({
  attachments = [],
  modalMode = 'Add', // 'Add' | 'Edit' | 'View'
  onUploadFiles,
  onRemoveAttachment,
  acceptedFileTypes = '.pdf,.png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx,.mp4,.webm,.avi,.mov',
  fileInputId = 'report-file-input',
}) => {
  return (
    <div className="mt-4 pt-3 border-t border-gray-100">
      <div className="flex items-center justify-between mb-2">
        <label className="text-xs font-bold text-aimhi-textlight-neutral m-0 flex items-center gap-1.5">
          <FaPaperclip className="text-xs text-aimhi-textlight-muted" />
          Attachments ({attachments.length})
        </label>

        {modalMode !== 'View' && onUploadFiles && (
          <label className="inline-flex items-center gap-1.5 text-xs font-semibold text-aimhi-textlight-neutral hover:underline cursor-pointer m-0">
            <FaCloudUploadAlt className="text-sm" />
            <span>Attach File/s</span>
            <input
              type="file"
              name="file"
              id={fileInputId}
              multiple
              onChange={onUploadFiles}
              className="hidden"
              accept={acceptedFileTypes}
            />
          </label>
        )}
      </div>

      {attachments.length === 0 ? (
        <div className="py-4 px-3 bg-gray-50 rounded-lg border border-dashed border-gray-200 text-center text-xs text-aimhi-textlight-muted">
          No attachments uploaded.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 mt-2">
          {attachments.map((file, index) => {
            const ext = (file.name || '').split('.').pop().toLowerCase();
            const isPdf = ext === 'pdf';
            const isExcel = ['xls', 'xlsx', 'csv'].includes(ext);

            return (
              <div
                key={file.id || index}
                className="relative p-2.5 rounded-lg border border-gray-200 bg-white hover:border-gray-300 transition-all flex flex-col items-center text-center group"
              >
                {modalMode !== 'View' && onRemoveAttachment && (
                  <button
                    type="button"
                    onClick={() => onRemoveAttachment(file, index)}
                    className="absolute top-1 right-1 p-1 text-gray-400 hover:text-aimhi-danger rounded transition-colors cursor-pointer"
                    title="Remove attachment"
                  >
                    <FaTimes size={10} />
                  </button>
                )}

                <div className="my-1">
                  {isPdf ? (
                    <FaFilePdf className="w-8 h-8 text-aimhi-danger" />
                  ) : isExcel ? (
                    <FaFileExcel className="w-8 h-8 text-aimhi-success" />
                  ) : (
                    <FaPaperclip className="w-8 h-8 text-aimhi-textlight-muted" />
                  )}
                </div>

                <div className="w-full mt-1">
                  {file.link ? (
                    <a
                      href={file.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[11px] font-medium text-aimhi-textlight-neutral hover:text-aimhi-info hover:underline truncate block"
                      title={file.name}
                    >
                      {file.name}
                    </a>
                  ) : (
                    <span
                      className="text-[11px] font-medium text-aimhi-textlight-neutral truncate block"
                      title={file.name}
                    >
                      {file.name}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ReportAttachments;
